import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import tint70 from "@/assets/tint-70.jpg";
import tint35 from "@/assets/tint-35.jpg";
import tint20 from "@/assets/tint-20.jpg";
import tint5 from "@/assets/tint-5.jpg";

const tintLevels = [
  { value: 70, label: "70% (Clear)", image: tint70 },
  { value: 35, label: "35% (Legal)", image: tint35 },
  { value: 20, label: "20% (Dark)", image: tint20 },
  { value: 5, label: "5% (Limo)", image: tint5 },
];

const TintSimulator = () => {
  const [selectedTint, setSelectedTint] = useState(35);
  
  const getCurrentTint = () => {
    return tintLevels.find(t => t.value === selectedTint) || tintLevels[1];
  };

  return (
    <Card className="bg-card border-silver overflow-hidden">
      <CardContent className="p-8">
        <h3 className="text-2xl font-heading font-bold mb-6 uppercase">
          Interactive Tint Shade Simulator
        </h3>
        
        {/* Car Visualization */}
        <div className="relative mb-8 bg-gradient-to-b from-background to-muted rounded-lg overflow-hidden">
          <img 
            src={getCurrentTint().image} 
            alt={`Porsche 911 GT3 RS with ${getCurrentTint().label} window tint`}
            className="w-full h-auto transition-opacity duration-500"
          />
        </div>

        {/* Tint Level Selector */}
        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground uppercase tracking-wide">Select Tint Darkness</span>
            <span className="text-lg font-heading font-bold text-accent">
              {getCurrentTint().label}
            </span>
          </div>
          
          {/* Button Group */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {tintLevels.map((tint) => (
              <button
                key={tint.value}
                onClick={() => setSelectedTint(tint.value)}
                className={`
                  px-4 py-3 rounded-sm border-2 font-heading uppercase text-sm
                  transition-all duration-300
                  ${selectedTint === tint.value 
                    ? 'bg-accent text-accent-foreground border-accent shadow-[var(--shadow-gold-glow)]' 
                    : 'bg-card border-silver hover:border-accent'
                  }
                `}
              >
                {tint.label}
              </button>
            ))}
          </div>

          {/* Info Text */}
          <p className="text-sm text-muted-foreground text-center">
            Use the buttons above to see how different tint levels affect visibility and privacy. 
            Nevada legal limit is 35% for front side windows.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default TintSimulator;
